export default __webpack_public_path__ + "images/View_of_Lower_Limb_dark.c69ac76f118e0a1e766282d064095ac5.png";